
export const ID_SERVIZIO_CORSI_ITALIANO = '2019';
